module.exports = __webpack_public_path__ + "static/media/workof.e8d6b05e.png";